import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
const FourZeroFour = lazy(() => import('publicContainer/404'));
const PageNotAuthorized = lazy(() => import('publicContainer/401'));

/**
 * RouteRenderer component renders a list of routes based on the user's roles.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.person - The person object containing user information.
 * @param {Object} props.person.roles - The roles object containing user roles.
 * @param {Array} props.routesList - The list of route objects to be rendered.
 * @param {Object} props.routesList[].access - The array of roles that have access to the route.
 * @param {boolean} props.routesList[].exact - Whether the route should be matched exactly.
 * @param {string} props.routesList[].path - The path of the route.
 * @param {React.Component} props.routesList[].component - The component to be rendered for the route.
 *
 * @returns {JSX.Element} The rendered routes based on the user's roles.
 */
const RouteRenderer = ({ person, routesList }) => {
	return (
		<>
			{routesList.map((route, index) => {
				if (
					person.roles &&
					Object.keys(person.roles)
						.map(Number)
						.some((role) => route.access.includes(role))
				) {
					return <Route key={index} exact={route.exact} path={route.path} element={<route.component />} />;
				} else {
					return <Route key={index} path={route.path} element={<PageNotAuthorized />} />;
				}
			})}

			<Route path='*' key={'404'} element={<FourZeroFour some={'AppRouter Universal'} />} />
		</>
	);
};

export default RouteRenderer;
